import { distinctUntilChanged, filter, map, of, switchMap, timer } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, NavigationStart, Router, RouterOutlet
} from '@angular/router';

/** Navegacao mais rapida que isto nao mostra a barra: ela so piscaria. */
export const ATRASO_BARRA_NAVEGACAO_MS = 150;

@Component({
  selector: 'app-root',
  imports: [
    AsyncPipe,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly router = inject(Router);

  title = 'itc-digital-front';

  // Os guards (a espera do Keycloak num F5, a consulta de assinaturas do
  // AppGuard) e o download da tela acontecem antes de a rota trocar: sem sinal
  // nenhum, o clique parecia nao ter feito nada (2026-09-22).
  readonly navegando$ = this.router.events.pipe(
    filter(evento =>
      evento instanceof NavigationStart || evento instanceof NavigationEnd || evento instanceof NavigationCancel ||
      evento instanceof NavigationError || evento instanceof NavigationSkipped
    ),
    switchMap(evento => evento instanceof NavigationStart
      ? timer(ATRASO_BARRA_NAVEGACAO_MS).pipe(map(() => true))
      : of(false)),
    distinctUntilChanged()
  );
}
